import { SearchSpellingResultRow } from '@oare/types';

/**
 * Spelling choices the user made on the Lexical Info step, keyed by discourse
 * uuid. A key with a null spellingUuid means the user cleared the selection;
 * words without a key get the automatic pick.
 */
export interface ManualSpellingSelections {
  [discourseUuid: string]: {
    spellingUuid: string | null;
    transcription: string | null;
  };
}

/** The matches, most frequent first, as the spelling dialogs list them. */
export const sortByOccurrences = (
  forms: SearchSpellingResultRow[]
): SearchSpellingResultRow[] =>
  [...forms].sort((a, b) => b.occurrences - a.occurrences);

/**
 * The automatic spelling pick: the only match, or the most frequent match
 * when it occurs more than twice as often as the runner-up.
 */
export const autoSelectSpelling = (
  forms: SearchSpellingResultRow[]
): SearchSpellingResultRow | undefined => {
  if (forms.length === 1) {
    return forms[0];
  }
  if (forms.length >= 2) {
    const [first, second] = sortByOccurrences(forms);
    if (first.occurrences > 2 * second.occurrences) {
      return first;
    }
  }
  return undefined;
};
